import { render, staticRenderFns } from "./addSurveyQuestion.vue?vue&type=template&id=1f555d4c"
import script from "./addSurveyQuestion.vue?vue&type=script&lang=js"
export * from "./addSurveyQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports